import React from "react";
import "./yatri.scss";
import { Box, Container, Grid, Typography } from "@mui/material";
import SEO from "../../seo/SEO";

function YatriPack() {
  const pricingData = [
    {
      price: "₹999",
      title: "Essential Pack",
      desc: "All basic hygiene essentials for a hassle-free yatra.",
      btn: "Order Essential Pack",
    },
    {
      price: "₹1499",
      title: "Yatri Comfort Pack",
      desc: "Complete comfort & hygiene for your journey.",
      btn: "Order Yatri Pack",
      featured: true,
    },
    {
      price: "₹1999",
      title: "Premium Pilgrim Pack",
      desc: "All essentials + Reunite Band for extra safety & peace of mind.",
      btn: "Order Premium Pack",
    },
  ];

  const steps = [
    {
      icon: "/assets/yatri-pack/icons/safe.svg",
      title: "Safe",
      desc: "Travel essentials to keep you protected and worry-free.",
    },
    {
      icon: "/assets/yatri-pack/icons/carry.svg",
      title: "Easy to Carry",
      desc: "Compact and lightweight design so you can carry with ease.",
    },
    {
      icon: "/assets/yatri-pack/icons/quality.svg",
      title: "Premium Quality",
      desc: "Trusted brands and high-quality items for the best experience.",
    },
    {
      icon: "/assets/yatri-pack/icons/quality.svg",
      title: "Saves Time",
      desc: "All your travel essentials in one pack. No last-minute shopping.",
    },
    {
      icon: "/assets/yatri-pack/icons/pilgrim.svg",
      title: "Made for Pilgrims",
      desc: "Curated keeping pilgrims' real needs in mind for a better yatra.",
    },
    {
      icon: "/assets/yatri-pack/icons/care.svg",
      title: "Thoughtful Care",
      desc: "Supporting you at every step, so your journey remains blessed.",
    },
  ];

  const packItems = [
    "TISSUE PAPER",
    "SHOE COVER",
    "DISPOSABLE SOCKS",
    "WET TISSUE",
    "EYE MASK",
    "SANITIZER",
    "HANDWASH",
    "TOFFEE",
    "RAIN PONCHO",
    "ORS SACHET",
    "BOROLINE",
    "PLASTIC TUMBLER",
    "BAND-AID",
    "REUNITE TAG",
    "ROUTE GUIDE CARD",
    "DUST MASK",
    "ZIPPER POUCH",
  ];

  return (
    <>
      <SEO pageKey="yatriPack" />
      {/* Hero Banner */}
      <Box className="hero-banner">
        <Container maxWidth="lg">
          <Grid container>
            <Grid size={{ xs: 12, md: 10, lg: 8 }}>
              <div className="hero-content">
                <span className="badge-tag">INTRODUCING</span>

                <h1>YATRI PACK</h1>
                <h3>Everything You Need. Nothing You Forgot.</h3>
                <p>
                  Thoughtfully packed essentials for a safe,{" "}
                  <br className="d-none d-md-inline" /> comfortable and blessed
                  journey to Mata Rani.
                </p>
                <div className="hero-buttons">
                  <a
                    href="#choosePack"
                    className="reserve-btn text-decoration-none"
                  >
                    CHOOSE YOUR PACK
                  </a>
                  <a
                    href="#whatsInside"
                    className="learn-btn text-decoration-none"
                  >
                    WHAT’S INSIDE
                  </a>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* What's Inside Your Yatri Pack */}
      <section className="howItWorks yatriPack pb-0" id="whatsInside">
        <img
          className="yatriCornerImg"
          src="/assets/yatri-pack/side-img.webp"
          alt=""
        />
        <Container maxWidth="lg">
          <Grid
            container
            spacing={{ xl: 5, lg: 4, md: 4, sm: 4, xs: 3 }}
            alignItems="center"
          >
            {/* Left Image */}
            <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
              <Box className="yatriImageBox">
                <img
                  src="/assets/yatri-pack/yatri-pack.webp"
                  alt="Yatri Pack - 17 essential items"
                />
              </Box>
            </Grid>

            {/* Right Content */}
            <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
              <Box className="yatriContent">
                <Box className="templeInnerHeading">
                  <h2 className="mt-1">
                    What's Inside Your <span>Yatri Pack?</span>
                  </h2>

                  <p>
                    17 carefully chosen essentials, packed in a durable pouch
                    that travels as lightly as you do.
                  </p>
                </Box>

                <Box className="packItems">
                  {packItems.map((item, index) => (
                    <Box className="packItem" key={index}>
                      <span className="checkIcon">✓</span>
                      <Typography component="span">{item}</Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Why Pilgrims Love Yatri Pack */}
      <section className="howItWorks pb-0">
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 2, sm: 2.5, md: 3, lg: 4 }}>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <Box className="templeInnerHeading">
                <h2 className="mt-1">Why Pilgrims Love Yatri Pack</h2>
                <p>
                  Carefully designed to make your yatra safe, comfortable, and
                  truly blessed.
                </p>
              </Box>
            </Grid>

            {steps.map((item, index) => (
              <Grid
                key={index}
                size={{ xl: 4, lg: 4, md: 6, sm: 6, xs: 12 }}
              >
                <Box className="workCard">
                  <div className="iconBox">
                    <img
                      src={item.icon}
                      alt={item.title}
                      height="25"
                      width="25"
                    />
                  </div>

                  <Typography variant="h6">{item.title}</Typography>

                  <Typography className="description">{item.desc}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      {/* Banner 1: Reunite QR Band */}
      <section className="yatriCardBannerSection pb-0">
        <Container maxWidth="lg">
          <Box className="qrBandBanner">
            <div className="bannerContent">
              <span className="badgeTag">EXTRA SAFETY WITH</span>

              <h2>Reunite QR Band</h2>

              <p>
                A small band with a big purpose — your safety, always
                connected.
              </p>

              <div className="featureList">
                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/qr.svg"
                      alt="QR Code"
                      className="img-fluid"
                    />
                  </span>
                  <span>QR for Quick ID</span>
                </div>

                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/phone.svg"
                      alt="Emergency Contact"
                      className="img-fluid"
                    />
                  </span>
                  <span>Emergency Contact</span>
                </div>

                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/kids.svg"
                      alt="Family"
                      className="img-fluid"
                    />
                  </span>
                  <span>Kids, Elderly & Family</span>
                </div>

                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/shield.svg"
                      alt="Waterproof"
                      className="img-fluid"
                    />
                  </span>
                  <span>Waterproof & Durable</span>
                </div>
              </div>

              <button className="knowBtn">KNOW MORE</button>
            </div>
          </Box>
        </Container>
      </section>

      {/* Banner 2: Smart Walking Stick */}
      <section className="yatriCardBannerSection pb-0">
        <Container maxWidth="lg">
          <Box className="qrBandBanner walikingStick walkingStick">
            <div className="bannerContent">
              <span className="badgeTag">YATRASATHI</span>

              <h2>Navi Stick</h2>

              <p>
                Your perfect yatra companion — support, safety, stability.
              </p>

              <div className="featureList">
                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/grip.svg"
                      alt="Ergonomic Grip"
                      className="img-fluid"
                    />
                  </span>
                  <span>Ergonomic Grip</span>
                </div>

                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/support.svg"
                      alt="Walking Support"
                      className="img-fluid"
                    />
                  </span>
                  <span>Walking Support</span>
                </div>

                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/led.svg"
                      alt="Built-in LED Light"
                      className="img-fluid"
                    />
                  </span>
                  <span>Built-in LED Light</span>
                </div>

                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/anti-slip.svg"
                      alt="Anti-Slip"
                      className="img-fluid"
                    />
                  </span>
                  <span>Sturdy & Anti-Slip</span>
                </div>
              </div>

              <button className="knowBtn">KNOW MORE</button>
            </div>
          </Box>
        </Container>
      </section>

      {/* Banner 3: MandirWiki App */}
      <section className="yatriCardBannerSection pb-0" id="thirdBanner">
        <Container maxWidth="lg">
          <Box className="qrBandBanner thirdBanner">
            <div className="bannerContent">
              <span className="badgeTag">MANDIRWIKI APP</span>

              <h2>Order Easily on the MandirWiki App</h2>

              <p>
                Be prepared. Travel better. Everything you need for a comfortable
                and blessed yatra.
              </p>

              <div className="featureList">
                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/payment.svg"
                      alt="Payment"
                      className="img-fluid"
                    />
                  </span>
                  <span>Secure Payment</span>
                </div>

                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/booking.svg"
                      alt="Booking"
                      className="img-fluid"
                    />
                  </span>
                  <span>Quick & Easy Booking</span>
                </div>

                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/delivery.svg"
                      alt="Delivery"
                      className="img-fluid"
                    />
                  </span>
                  <span>Fast Delivery</span>
                </div>

                <div className="featureItem">
                  <span className="icon">
                    <img
                      src="/assets/yatri-pack/icons/travel.svg"
                      alt="Travel"
                      className="img-fluid"
                    />
                  </span>
                  <span>Travel Worry-Free</span>
                </div>
              </div>

              <button className="knowBtn">ORDER NOW</button>
            </div>
          </Box>
        </Container>
      </section>

      {/* Pricing Cards */}
      <section className="serviceCardsSection" id="choosePack">
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 3, md: 4 }}>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <Box className="templeInnerHeading">
                <h2 className="mt-1">Choose Your Perfect Pack</h2>
                <p>Travel Light. Travel Right.</p>
              </Box>
            </Grid>

            {pricingData.map((item, index) => (
              <Grid
                key={index}
                size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }}
              >
                <Box
                  className={`pricingCard ${item.featured ? "featured" : ""}`}
                >
                  {item.featured && (
                    <span className="popularBadge">Most Popular</span>
                  )}

                  <h3 className="price">{item.price}</h3>

                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>

                  <button>{item.btn}</button>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>
    </>
  );
}

export default YatriPack;